import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, vModelText as _vModelText, withDirectives as _withDirectives, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, vModelRadio as _vModelRadio, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, vModelCheckbox as _vModelCheckbox, Transition as _Transition, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "container" }
const _hoisted_2 = { class: "row" }
const _hoisted_3 = { class: "col-lg-4" }
const _hoisted_4 = { class: "home__info--item home__info--item-1" }
const _hoisted_5 = { class: "home__info__item--left" }
const _hoisted_6 = { class: "home__info__item--icon" }
const _hoisted_7 = { class: "home__info__item--right" }
const _hoisted_8 = { class: "home__info__item--title" }
const _hoisted_9 = /*#__PURE__*/_createVNode("div", { class: "home__info__item--text" }, "Уникальных аттрибутов", -1)
const _hoisted_10 = { class: "col-lg-4" }
const _hoisted_11 = { class: "home__info--item home__info--item-2" }
const _hoisted_12 = { class: "home__info__item--left" }
const _hoisted_13 = { class: "home__info__item--icon" }
const _hoisted_14 = { class: "home__info__item--right" }
const _hoisted_15 = { class: "home__info__item--title" }
const _hoisted_16 = /*#__PURE__*/_createVNode("div", { class: "home__info__item--text" }, "Уникальных локации", -1)
const _hoisted_17 = { class: "col-lg-4" }
const _hoisted_18 = { class: "home__info--item home__info--item-4" }
const _hoisted_19 = { class: "home__info__item--left" }
const _hoisted_20 = { class: "home__info__item--icon" }
const _hoisted_21 = { class: "home__info__item--right" }
const _hoisted_22 = { class: "home__info__item--title" }
const _hoisted_23 = /*#__PURE__*/_createVNode("div", { class: "home__info__item--text" }, "Загруженных бюллетеней", -1)
const _hoisted_24 = { class: "container" }
const _hoisted_25 = { class: "row margin-user-table" }
const _hoisted_26 = { class: "col-4" }
const _hoisted_27 = { class: "col-2 block-radio" }
const _hoisted_28 = { class: "radio-conficuration" }
const _hoisted_29 = /*#__PURE__*/_createVNode("div", {
  class: "circle-label",
  id: "circle-label-1"
}, null, -1)
const _hoisted_30 = /*#__PURE__*/_createTextVNode(" Локация")
const _hoisted_31 = { class: "col-2 block-radio" }
const _hoisted_32 = { class: "radio-conficuration" }
const _hoisted_33 = /*#__PURE__*/_createVNode("div", {
  class: "circle-label",
  id: "circle-label-2"
}, null, -1)
const _hoisted_34 = /*#__PURE__*/_createTextVNode(" Атрибут")
const _hoisted_35 = { class: "col-4 block-radio" }
const _hoisted_36 = { class: "radio-conficuration" }
const _hoisted_37 = /*#__PURE__*/_createVNode("div", {
  class: "circle-label",
  id: "circle-label-3"
}, null, -1)
const _hoisted_38 = /*#__PURE__*/_createTextVNode(" Бюллетень")
const _hoisted_39 = { class: "container" }
const _hoisted_40 = { class: "row" }
const _hoisted_41 = { class: "col margin-user-table" }
const _hoisted_42 = { class: "user-table" }
const _hoisted_43 = {
  key: 0,
  class: "user-table text-information"
}
const _hoisted_44 = /*#__PURE__*/_createVNode("th", { class: "user-table__id" }, null, -1)
const _hoisted_45 = /*#__PURE__*/_createVNode("th", { class: "user-table__id" }, "ID", -1)
const _hoisted_46 = { class: "user-table__main" }
const _hoisted_47 = { class: "arraw-table" }
const _hoisted_48 = /*#__PURE__*/_createVNode("p", { class: "table-text" }, "Название", -1)
const _hoisted_49 = { class: "arraws" }
const _hoisted_50 = /*#__PURE__*/_createVNode("th", { class: "user-table__id" }, null, -1)
const _hoisted_51 = { class: "user-table__id" }
const _hoisted_52 = {
  key: 1,
  class: "user-table text-information"
}
const _hoisted_53 = { class: "user-table__id" }
const _hoisted_54 = /*#__PURE__*/_createVNode("th", { class: "user-table__id" }, "ID", -1)
const _hoisted_55 = { class: "user-table__main" }
const _hoisted_56 = { class: "arraw-table" }
const _hoisted_57 = { class: "arraws" }
const _hoisted_58 = { class: "user-table__id" }
const _hoisted_59 = /*#__PURE__*/_createVNode("th", { class: "user-table__operation" }, "Единица измерения", -1)
const _hoisted_60 = /*#__PURE__*/_createVNode("th", { class: "user-table__id" }, null, -1)
const _hoisted_61 = { class: "user-table__id" }
const _hoisted_62 = { class: "td-rollback" }
const _hoisted_63 = /*#__PURE__*/_createTextVNode(" Откат ")
const _hoisted_64 = { class: "container" }
const _hoisted_65 = { class: "row" }
const _hoisted_66 = { class: "col-6 margin-user-table" }
const _hoisted_67 = {
  key: 0,
  class: "col-4"
}
const _hoisted_68 = { class: "pagination" }
const _hoisted_69 = {
  key: 1,
  class: "col-4"
}
const _hoisted_70 = { class: "pagination" }
const _hoisted_71 = {
  key: 0,
  id: "myModal",
  class: "modal"
}
const _hoisted_72 = { class: "modal-content" }
const _hoisted_73 = { class: "modalcontent" }
const _hoisted_74 = /*#__PURE__*/_createVNode("h2", { class: "modalcontent__h2" }, " Вы действительно хотите Объединить данные? ", -1)
const _hoisted_75 = { class: "content-margin" }
const _hoisted_76 = { class: "bulletin-input" }
const _hoisted_77 = { class: "bulletin-input__content" }
const _hoisted_78 = { class: "modalcontent__margin modalcontent__margin-faq" }
const _hoisted_79 = /*#__PURE__*/_createVNode("button", { class: "button-cancel" }, "ОТМЕНА", -1)
const _hoisted_80 = {
  key: 0,
  id: "myModal",
  class: "modal"
}
const _hoisted_81 = { class: "modal-content modal-content-edit" }
const _hoisted_82 = { class: "modalcontent" }
const _hoisted_83 = /*#__PURE__*/_createVNode("h2", { class: "modalcontent__h2" }, "Редактировать данные", -1)
const _hoisted_84 = { class: "content-margin" }
const _hoisted_85 = { class: "modalcontent__margin" }
const _hoisted_86 = { class: "edit-bulletin-with" }
const _hoisted_87 = /*#__PURE__*/_createVNode("p", { class: "modalcontent__text-info" }, "Название", -1)
const _hoisted_88 = { key: 0 }
const _hoisted_89 = /*#__PURE__*/_createVNode("p", { class: "modalcontent__text-info" }, "Значение", -1)
const _hoisted_90 = { class: "modalcontent__margin modalcontent__margin-faq" }
const _hoisted_91 = {
  key: 0,
  id: "myModal",
  class: "modal"
}
const _hoisted_92 = { class: "modal-content" }
const _hoisted_93 = { class: "modalcontent" }
const _hoisted_94 = /*#__PURE__*/_createVNode("h2", { class: "modalcontent__h2 modalcontent__h2-delete" }, " Вы действительно хотите Удалить данные? ", -1)
const _hoisted_95 = { class: "content-margin" }
const _hoisted_96 = { class: "bulletin-input" }
const _hoisted_97 = { class: "bulletin-input__content" }
const _hoisted_98 = { class: "modalcontent__margin modalcontent__margin-faq" }
const _hoisted_99 = {
  key: 0,
  id: "myModal",
  class: "modal"
}
const _hoisted_100 = { class: "modal-content" }
const _hoisted_101 = { class: "modalcontent" }
const _hoisted_102 = /*#__PURE__*/_createVNode("h2", { class: "modalcontent__h2 modalcontent__h2-delete" }, " Вы действительно хотите восстановить данные? ", -1)
const _hoisted_103 = { class: "content-margin" }
const _hoisted_104 = { class: "bulletin-input" }
const _hoisted_105 = { class: "bulletin-input__content" }
const _hoisted_106 = { class: "modalcontent__margin modalcontent__margin-faq" }
const _hoisted_107 = {
  key: 0,
  id: "myModal",
  class: "modal"
}
const _hoisted_108 = { class: "modal-content modal-content-edit" }
const _hoisted_109 = { class: "modalcontent" }
const _hoisted_110 = /*#__PURE__*/_createVNode("h2", { class: "modalcontent__h2" }, "Редактировать данные", -1)
const _hoisted_111 = { class: "content-margin" }
const _hoisted_112 = { class: "modalcontent__margin" }
const _hoisted_113 = { class: "edit-bulletin-with" }
const _hoisted_114 = /*#__PURE__*/_createVNode("p", { class: "modalcontent__text-info" }, "Название", -1)
const _hoisted_115 = { class: "modalcontent__margin modalcontent__margin-faq" }

export function render(_ctx, _cache) {
  const _component_admin_import = _resolveComponent("admin-import")
  const _component_svg_icon = _resolveComponent("svg-icon")
  const _component_main_footer = _resolveComponent("main-footer")

  return (_openBlock(), _createBlock(_Fragment, null, [
    _createVNode(_component_admin_import),
    _createVNode("div", _hoisted_1, [
      _createVNode("div", _hoisted_2, [
        _createVNode("div", _hoisted_3, [
          _createVNode("div", _hoisted_4, [
            _createVNode("div", _hoisted_5, [
              _createVNode("div", _hoisted_6, [
                _createVNode(_component_svg_icon, { name: "user_check" })
              ])
            ]),
            _createVNode("div", _hoisted_7, [
              _createVNode("div", _hoisted_8, _toDisplayString(_ctx.numberValues.atrributes), 1),
              _hoisted_9
            ])
          ])
        ]),
        _createVNode("div", _hoisted_10, [
          _createVNode("div", _hoisted_11, [
            _createVNode("div", _hoisted_12, [
              _createVNode("div", _hoisted_13, [
                _createVNode(_component_svg_icon, { name: "worldLocation" })
              ])
            ]),
            _createVNode("div", _hoisted_14, [
              _createVNode("div", _hoisted_15, _toDisplayString(_ctx.numberValues.locations), 1),
              _hoisted_16
            ])
          ])
        ]),
        _createVNode("div", _hoisted_17, [
          _createVNode("div", _hoisted_18, [
            _createVNode("div", _hoisted_19, [
              _createVNode("div", _hoisted_20, [
                _createVNode(_component_svg_icon, { name: "download" })
              ])
            ]),
            _createVNode("div", _hoisted_21, [
              _createVNode("div", _hoisted_22, _toDisplayString(_ctx.numberValues.bulletins), 1),
              _hoisted_23
            ])
          ])
        ])
      ])
    ]),
    _createVNode("div", _hoisted_24, [
      _createVNode("div", _hoisted_25, [
        _createVNode("div", _hoisted_26, [
          (!_ctx.bulletinIsActive)
            ? _withDirectives((_openBlock(), _createBlock("input", {
                key: 0,
                class: "input-search",
                type: "text",
                "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => (_ctx.configuration.search = $event)),
                placeholder: "Номер, Название, ID",
                onKeyup: _cache[2] || (_cache[2] = $event => (_ctx.endAndStartTimer()))
              }, null, 544)), [
                [_vModelText, _ctx.configuration.search]
              ])
            : _createCommentVNode("", true)
        ]),
        _createVNode("div", _hoisted_27, [
          _createVNode("label", _hoisted_28, [
            _withDirectives(_createVNode("input", {
              class: "input-checked",
              type: "radio",
              name: "drone",
              value: "location",
              "onUpdate:modelValue": _cache[3] || (_cache[3] = $event => (_ctx.configuration.filterBy = $event)),
              onChange: _cache[4] || (_cache[4] = $event => (_ctx.getBulletinTable()))
            }, null, 544), [
              [_vModelRadio, _ctx.configuration.filterBy]
            ]),
            _hoisted_29,
            _hoisted_30
          ])
        ]),
        _createVNode("div", _hoisted_31, [
          _createVNode("label", _hoisted_32, [
            _withDirectives(_createVNode("input", {
              class: "input-checked",
              type: "radio",
              name: "drone",
              value: "attribute",
              "onUpdate:modelValue": _cache[5] || (_cache[5] = $event => (_ctx.configuration.filterBy = $event)),
              onChange: _cache[6] || (_cache[6] = $event => (_ctx.getBulletinTable()))
            }, null, 544), [
              [_vModelRadio, _ctx.configuration.filterBy]
            ]),
            _hoisted_33,
            _hoisted_34
          ])
        ]),
        _createVNode("div", _hoisted_35, [
          _createVNode("label", _hoisted_36, [
            _createVNode("input", {
              class: "input-checked",
              type: "radio",
              name: "drone",
              onChange: _cache[7] || (_cache[7] = $event => (_ctx.getBulletin()))
            }, null, 32),
            _hoisted_37,
            _hoisted_38
          ])
        ])
      ])
    ]),
    _createVNode("div", _hoisted_39, [
      _createVNode("div", _hoisted_40, [
        _createVNode("div", _hoisted_41, [
          _createVNode("div", _hoisted_42, [
            (_ctx.bulletinIsActive)
              ? (_openBlock(), _createBlock("table", _hoisted_43, [
                  _createVNode("thead", null, [
                    _createVNode("tr", null, [
                      _hoisted_44,
                      _hoisted_45,
                      _createVNode("th", _hoisted_46, [
                        _createVNode("div", _hoisted_47, [
                          _hoisted_48,
                          _createVNode("div", _hoisted_49, [
                            _createVNode(_component_svg_icon, {
                              class: {
                          active: _ctx.isActiveUp
                        },
                              name: "arrawUp",
                              onClick: _cache[8] || (_cache[8] = $event => (_ctx.bulletinSortTableArrow(1)))
                            }, null, 8, ["class"]),
                            _createVNode(_component_svg_icon, {
                              class: {
                          active: _ctx.isActiveDown
                        },
                              name: "arrawDown",
                              onClick: _cache[9] || (_cache[9] = $event => (_ctx.bulletinSortTableArrow(0)))
                            }, null, 8, ["class"])
                          ])
                        ])
                      ]),
                      _hoisted_50
                    ])
                  ]),
                  _createVNode("tbody", null, [
                    (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.bulletinTable, (bulletin, index) => {
                      return (_openBlock(), _createBlock("tr", {
                        key: index,
                        class: "check"
                      }, [
                        _createVNode("td", _hoisted_51, [
                          _withDirectives(_createVNode("input", {
                            type: "checkbox",
                            "onUpdate:modelValue": $event => (_ctx.checkbox[index] = $event),
                            value: false,
                            class: "checkbox"
                          }, null, 8, ["onUpdate:modelValue"]), [
                            [_vModelCheckbox, _ctx.checkbox[index]]
                          ])
                        ]),
                        _createVNode("td", null, _toDisplayString(bulletin.id), 1),
                        _createVNode("td", null, _toDisplayString(bulletin.name), 1)
                      ]))
                    }), 128 /* KEYED_FRAGMENT */))
                  ])
                ]))
              : (_openBlock(), _createBlock("table", _hoisted_52, [
                  _createVNode("thead", null, [
                    _createVNode("tr", null, [
                      _createVNode("th", _hoisted_53, [
                        _createVNode("input", {
                          type: "checkbox",
                          onChange: _cache[10] || (_cache[10] = $event => (_ctx.selectAll())),
                          class: "main-checkbox"
                        }, null, 32)
                      ]),
                      _hoisted_54,
                      _createVNode("th", _hoisted_55, [
                        _createVNode("div", _hoisted_56, [
                          _createVNode("p", {
                            onClick: _cache[11] || (_cache[11] = $event => (_ctx.sortTable('name'))),
                            class: "table-text"
                          }, " Название "),
                          _createVNode("div", _hoisted_57, [
                            _createVNode(_component_svg_icon, {
                              class: {
                          active: _ctx.isActiveUp
                        },
                              name: "arrawUp",
                              onClick: _cache[12] || (_cache[12] = $event => (_ctx.sortTableArrow(1)))
                            }, null, 8, ["class"]),
                            _createVNode(_component_svg_icon, {
                              class: {
                          active: _ctx.isActiveDown
                        },
                              name: "arrawDown",
                              onClick: _cache[13] || (_cache[13] = $event => (_ctx.sortTableArrow(0)))
                            }, null, 8, ["class"])
                          ])
                        ])
                      ]),
                      _createVNode("th", _hoisted_58, [
                        _createVNode("p", {
                          onClick: _cache[14] || (_cache[14] = $event => (_ctx.sortTable('id'))),
                          class: "table-text"
                        }, "ID в базе")
                      ]),
                      _hoisted_59,
                      _hoisted_60
                    ])
                  ]),
                  _createVNode("tbody", null, [
                    (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.bulletinTable, (bulletin, index) => {
                      return (_openBlock(), _createBlock("tr", {
                        key: index,
                        class: "check"
                      }, [
                        _createVNode("td", _hoisted_61, [
                          _withDirectives(_createVNode("input", {
                            type: "checkbox",
                            "onUpdate:modelValue": $event => (_ctx.checkbox[index] = $event),
                            value: false,
                            class: "checkbox",
                            onChange: _cache[15] || (_cache[15] = $event => (_ctx.watchMoreSelect()))
                          }, null, 40, ["onUpdate:modelValue"]), [
                            [_vModelCheckbox, _ctx.checkbox[index]]
                          ])
                        ]),
                        _createVNode("td", null, _toDisplayString(bulletin.id), 1),
                        _createVNode("td", null, _toDisplayString(bulletin.name), 1),
                        _createVNode("td", null, _toDisplayString(_ctx.configuration.filterBy == 'location'
                      ? bulletin.location_id
                      : bulletin.report_attribute_id), 1),
                        _createVNode("td", null, _toDisplayString(_ctx.configuration.filterBy == 'location'
                      ? '-'
                      : bulletin.attribute.unit), 1),
                        _createVNode("td", _hoisted_62, [
                          (bulletin.recovery_id !== null)
                            ? (_openBlock(), _createBlock("div", {
                                key: 0,
                                class: "td-rollback",
                                onClick: $event => (_ctx.rollBackActiv(bulletin.id, bulletin.name))
                              }, [
                                _createVNode(_component_svg_icon, { name: "rollback" }),
                                _hoisted_63
                              ], 8, ["onClick"]))
                            : _createCommentVNode("", true)
                        ])
                      ]))
                    }), 128 /* KEYED_FRAGMENT */))
                  ])
                ]))
          ])
        ])
      ])
    ]),
    _createVNode("div", _hoisted_64, [
      _createVNode("div", _hoisted_65, [
        _createVNode("div", _hoisted_66, [
          (!_ctx.bulletinIsActive)
            ? (_openBlock(), _createBlock("button", {
                key: 0,
                class: "import-tab__button-change",
                onClick: _cache[16] || (_cache[16] = $event => (_ctx.joinBulletin()))
              }, " Объединить "))
            : _createCommentVNode("", true),
          (!_ctx.moreselect && !_ctx.bulletinIsActive)
            ? (_openBlock(), _createBlock("button", {
                key: 1,
                class: "import-tab__button-change",
                onClick: _cache[17] || (_cache[17] = $event => (_ctx.editBulletin()))
              }, " РЕДАКТИРОВАТЬ "))
            : _createCommentVNode("", true),
          (!_ctx.bulletinIsActive)
            ? (_openBlock(), _createBlock("button", {
                key: 2,
                class: "import-tab__button-change",
                onClick: _cache[18] || (_cache[18] = $event => (_ctx.deleteBulletin()))
              }, " Удалить "))
            : _createCommentVNode("", true),
          (_ctx.bulletinIsActive)
            ? (_openBlock(), _createBlock("button", {
                key: 3,
                class: "import-tab__button-change",
                onClick: _cache[19] || (_cache[19] = $event => (_ctx.changeBulletin()))
              }, " РЕДАКТИРОВАТЬ "))
            : _createCommentVNode("", true)
        ]),
        (!_ctx.bulletinIsActive)
          ? (_openBlock(), _createBlock("div", _hoisted_67, [
              _createVNode("ul", _hoisted_68, [
                (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.linkPage, (page) => {
                  return (_openBlock(), _createBlock("li", {
                    class: { ['page-active']: page.active },
                    key: page.id,
                    onClick: $event => (_ctx.pageLink(page.url))
                  }, [
                    _createVNode("p", {
                      innerHTML: page.label
                    }, null, 8, ["innerHTML"])
                  ], 10, ["onClick"]))
                }), 128 /* KEYED_FRAGMENT */))
              ])
            ]))
          : _createCommentVNode("", true),
        (_ctx.bulletinIsActive)
          ? (_openBlock(), _createBlock("div", _hoisted_69, [
              _createVNode("ul", _hoisted_70, [
                (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.linkPage, (page) => {
                  return (_openBlock(), _createBlock("li", {
                    class: { ['page-active']: page.active },
                    key: page.id,
                    onClick: $event => (_ctx.pageLinkBulletin(page.url))
                  }, [
                    _createVNode("p", {
                      innerHTML: page.label
                    }, null, 8, ["innerHTML"])
                  ], 10, ["onClick"]))
                }), 128 /* KEYED_FRAGMENT */))
              ])
            ]))
          : _createCommentVNode("", true)
      ])
    ]),
    _createVNode(_component_main_footer),
    _createVNode(_Transition, { name: "slide-fade" }, {
      default: _withCtx(() => [
        (_ctx.activeJoinBulletin)
          ? (_openBlock(), _createBlock("div", _hoisted_71, [
              _createVNode("div", _hoisted_72, [
                _createVNode("span", {
                  class: "close",
                  onClick: _cache[20] || (_cache[20] = $event => (_ctx.activeJoinBulletin = !_ctx.activeJoinBulletin))
                }, "×"),
                _createVNode("div", _hoisted_73, [
                  _hoisted_74,
                  _createVNode("div", _hoisted_75, [
                    (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.pushedvalue, (pushed, index) => {
                      return (_openBlock(), _createBlock("div", { key: index }, [
                        _createVNode("div", _hoisted_76, [
                          _withDirectives(_createVNode("input", {
                            type: "radio",
                            name: "name",
                            id: "",
                            value: pushed.id,
                            "onUpdate:modelValue": _cache[21] || (_cache[21] = $event => (_ctx.mainId = $event))
                          }, null, 8, ["value"]), [
                            [_vModelRadio, _ctx.mainId]
                          ]),
                          _createVNode("div", _hoisted_77, [
                            _createVNode("p", null, _toDisplayString(pushed.name), 1),
                            _createVNode("p", {
                              class: "necessarily cursive",
                              onClick: $event => (_ctx.deleteValues(index))
                            }, " × ", 8, ["onClick"])
                          ])
                        ])
                      ]))
                    }), 128 /* KEYED_FRAGMENT */))
                  ]),
                  _createVNode("div", _hoisted_78, [
                    _createVNode("button", {
                      class: "button-using",
                      onClick: _cache[22] || (_cache[22] = $event => (_ctx.joinPut()))
                    }, "Объединить"),
                    _hoisted_79
                  ])
                ])
              ])
            ]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }),
    _createVNode(_Transition, { name: "slide-fade" }, {
      default: _withCtx(() => [
        (_ctx.editBulletinActive)
          ? (_openBlock(), _createBlock("div", _hoisted_80, [
              _createVNode("div", _hoisted_81, [
                _createVNode("span", {
                  class: "close",
                  onClick: _cache[23] || (_cache[23] = $event => (_ctx.editBulletinActive = !_ctx.editBulletinActive))
                }, "×"),
                _createVNode("div", _hoisted_82, [
                  _hoisted_83,
                  _createVNode("div", _hoisted_84, [
                    _createVNode("div", _hoisted_85, [
                      _createVNode("div", _hoisted_86, [
                        _hoisted_87,
                        _withDirectives(_createVNode("input", {
                          type: "text",
                          class: "modalcontent__input modalcontent__input-edit",
                          "onUpdate:modelValue": _cache[24] || (_cache[24] = $event => (_ctx.pushedvalue[0].name = $event))
                        }, null, 512), [
                          [_vModelText, _ctx.pushedvalue[0].name]
                        ]),
                        (_ctx.watchEditUniteValue)
                          ? (_openBlock(), _createBlock("div", _hoisted_88, [
                              _hoisted_89,
                              _withDirectives(_createVNode("input", {
                                type: "text",
                                class: "modalcontent__input modalcontent__input-edit",
                                "onUpdate:modelValue": _cache[25] || (_cache[25] = $event => (_ctx.editUniteValue = $event))
                              }, null, 512), [
                                [_vModelText, _ctx.editUniteValue]
                              ])
                            ]))
                          : _createCommentVNode("", true)
                      ])
                    ])
                  ]),
                  _createVNode("div", _hoisted_90, [
                    _createVNode("button", {
                      class: "button-using",
                      onClick: _cache[26] || (_cache[26] = $event => (_ctx.putEditBulletin()))
                    }, " СОХРАНИТЬ "),
                    _createVNode("button", {
                      class: "button-cancel",
                      onClick: _cache[27] || (_cache[27] = $event => (_ctx.editBulletinActive = !_ctx.editBulletinActive))
                    }, " ОТМЕНА ")
                  ])
                ])
              ])
            ]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }),
    _createVNode(_Transition, { name: "slide-fade" }, {
      default: _withCtx(() => [
        (_ctx.deleteBulletinActive)
          ? (_openBlock(), _createBlock("div", _hoisted_91, [
              _createVNode("div", _hoisted_92, [
                _createVNode("span", {
                  class: "close",
                  onClick: _cache[28] || (_cache[28] = $event => (_ctx.deleteBulletinActive = !_ctx.deleteBulletinActive))
                }, "×"),
                _createVNode("div", _hoisted_93, [
                  _hoisted_94,
                  _createVNode("div", _hoisted_95, [
                    (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.pushedvalue, (pushed, index) => {
                      return (_openBlock(), _createBlock("div", { key: index }, [
                        _createVNode("div", _hoisted_96, [
                          _createVNode("div", _hoisted_97, [
                            _createVNode("p", null, _toDisplayString(pushed.name), 1),
                            _createVNode("p", {
                              class: "necessarily cursive",
                              onClick: $event => (_ctx.deleteValues(index))
                            }, " × ", 8, ["onClick"])
                          ])
                        ])
                      ]))
                    }), 128 /* KEYED_FRAGMENT */))
                  ]),
                  _createVNode("div", _hoisted_98, [
                    _createVNode("button", {
                      class: "button-using",
                      onClick: _cache[29] || (_cache[29] = $event => (_ctx.deletechackedBulletin()))
                    }, " Удалить "),
                    _createVNode("button", {
                      class: "button-cancel",
                      onClick: _cache[30] || (_cache[30] = $event => (_ctx.deleteBulletinActive = !_ctx.deleteBulletinActive))
                    }, " ОТМЕНА ")
                  ])
                ])
              ])
            ]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }),
    _createVNode(_Transition, { name: "slide-fade" }, {
      default: _withCtx(() => [
        (_ctx.rollBackIsActive)
          ? (_openBlock(), _createBlock("div", _hoisted_99, [
              _createVNode("div", _hoisted_100, [
                _createVNode("span", {
                  class: "close",
                  onClick: _cache[31] || (_cache[31] = $event => (_ctx.rollBackIsActive = !_ctx.rollBackIsActive))
                }, "×"),
                _createVNode("div", _hoisted_101, [
                  _hoisted_102,
                  _createVNode("div", _hoisted_103, [
                    _createVNode("div", null, [
                      _createVNode("div", _hoisted_104, [
                        _createVNode("div", _hoisted_105, [
                          _createVNode("p", null, _toDisplayString(_ctx.bulletinName), 1)
                        ])
                      ])
                    ])
                  ]),
                  _createVNode("div", _hoisted_106, [
                    _createVNode("button", {
                      class: "button-using",
                      onClick: _cache[32] || (_cache[32] = $event => (_ctx.bulletinRollBack()))
                    }, " откатить "),
                    _createVNode("button", {
                      class: "button-cancel",
                      onClick: _cache[33] || (_cache[33] = $event => (_ctx.rollBackIsActive = !_ctx.rollBackIsActive))
                    }, " ОТМЕНА ")
                  ])
                ])
              ])
            ]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }),
    _createVNode(_Transition, { name: "slide-fade" }, {
      default: _withCtx(() => [
        (_ctx.bulletinchangeActive)
          ? (_openBlock(), _createBlock("div", _hoisted_107, [
              _createVNode("div", _hoisted_108, [
                _createVNode("span", {
                  class: "close",
                  onClick: _cache[34] || (_cache[34] = $event => (_ctx.bulletinchangeActive = !_ctx.bulletinchangeActive))
                }, "×"),
                _createVNode("div", _hoisted_109, [
                  _hoisted_110,
                  _createVNode("div", _hoisted_111, [
                    _createVNode("div", _hoisted_112, [
                      _createVNode("div", _hoisted_113, [
                        _hoisted_114,
                        _withDirectives(_createVNode("input", {
                          type: "text",
                          class: "modalcontent__input modalcontent__input-edit",
                          "onUpdate:modelValue": _cache[35] || (_cache[35] = $event => (_ctx.pushedvalue[0].name = $event))
                        }, null, 512), [
                          [_vModelText, _ctx.pushedvalue[0].name]
                        ])
                      ])
                    ])
                  ]),
                  _createVNode("div", _hoisted_115, [
                    _createVNode("button", {
                      class: "button-using",
                      onClick: _cache[36] || (_cache[36] = $event => (_ctx.putBulletin()))
                    }, " СОХРАНИТЬ "),
                    _createVNode("button", {
                      class: "button-cancel",
                      onClick: _cache[37] || (_cache[37] = $event => (_ctx.bulletinchangeActive = !_ctx.bulletinchangeActive))
                    }, " ОТМЕНА ")
                  ])
                ])
              ])
            ]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    })
  ], 64 /* STABLE_FRAGMENT */))
}